import React, { useState } from 'react';
import moment from 'moment';
import { ClosePopupButton } from '../../../commonComponents/ClosePopupButton/ClosePopupButton';
import { PopupWrapper } from '../../../commonComponents/PopupWrapper/PopupWrapper';
import { DatePicker } from '../../DatePicker';
import styles from './index.module.sass';

// Helper function to get week info from selected range
const getSelectedWeek = (selectedRange) => {
  if (!selectedRange?.from || !selectedRange?.to) return null;

  const startDate = moment(selectedRange.from);
  const endDate = moment(selectedRange.to);

  const startWeek = startDate.isoWeek();
  const endWeek = endDate.isoWeek();

  // Return single week or range
  return startWeek === endWeek ? startWeek : `${startWeek}-${endWeek}`;
};

export const DatePickerModal = ({ selectedRange, setSelectedRange, onClose }) => {
  const [showResults, setShowResults] = useState(false);
  const selectedWeek = getSelectedWeek(selectedRange);

  const handleShowResults = () => {
    setSelectedRange(showResults);
    onClose();
  };

  return (
    <>
      <PopupWrapper />
      <section className={styles.invite_popup}>
        <ClosePopupButton handleClosePopupButtonClick={onClose} />
        <DatePicker
          navLayout="around"
          mode="range"
          required
          selectedRange={showResults}
          selected={showResults}
          onSelect={setShowResults}
        />
        <div className={styles.container} style={{ paddingTop: '0px' }}>
          <div style={{ borderBottom: '0.1rem solid #bfcdd9' }} />

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              paddingRight: '15px',
              paddingLeft: '15px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ fontSize: '15px' }}>Selected Week: </span>
              {selectedWeek && (
                <span style={{ fontSize: '15px', fontWeight: '600' }}>{selectedWeek}</span>
              )}
            </div>
            <div className={styles.buttons}>
              <button
                className={`${styles.button} ${styles.clear}`}
                onClick={() => {
                  setSelectedRange();
                  setShowResults();
                }}
              >
                Clear
              </button>
              <button className={`${styles.button} ${styles.actionb}`} onClick={handleShowResults}>
                Show Results
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
